import { useParams } from "react-router";
import { ProcedureType, SampleType } from "@/services/backend/types";
import DifferentiationTable from "./differentiation-table";
import { useShowDifferentiationQuery } from "@/services/backend/differentiation/service";

export function DifferentiationIndexRoute() {
  const { differentiationId } = useParams();
  const { data: diff } = useShowDifferentiationQuery({
    id: differentiationId!,
  });
  const immutable = !!diff?.differentiation.immutable;

  return (
    <div className="flex w-full flex-col space-y-4">
      <DifferentiationTable
        label="2N-RLT"
        sampleType={SampleType.AirMicrobial}
        procedureType={ProcedureType.RLT2N}
        ownerId={differentiationId as string}
        ownerType="differentiation.Differentiation"
        immutable={immutable}
      />
    </div>
  );
}
